
import Vue from "vue";
import { Component } from "vue-property-decorator";
import UpdateAnimationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/UpdateAnimationRequest";

@Component
export default class PageCreateAnimationLibraryComponent extends Vue {
  isLoading = false;
  name = "";
  file: File = null;
  base64Content: string = null;
  currentUrl = "";
  fileReadPromise: Promise<void> = Promise.resolve();

  get id(): string {
    return this.$route.params.id || "";
  }

  get title(): string {
    return this.id ? "Редактирование анимации" : "Добавление анимации";
  }

  get previewUrl(): string {
    if (this.file) {
      const url = window.URL || window.webkitURL;
      return url.createObjectURL(this.file);
    }
    return this.currentUrl;
  }

  async created() {
    if (!this.id) {
      return;
    }

    this.isLoading = true;
    try {
      const animations = await this.$api.AnimationService.getAnimationsAsync();
      const animation = (animations || []).find((item) => item.Id === this.id);
      if (!animation) {
        this.$notification.error("Анимация не найдена");
        this.$router.back();
        return;
      }
      this.name = animation.Name || "";
      this.currentUrl = animation.Url || "";
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  onFileChanged(file: File) {
    this.file = file;
    this.base64Content = null;
    if (!file) {
      return;
    }

    this.fileReadPromise = new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        this.base64Content = reader.result.toString();
        resolve();
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    try {
      await this.fileReadPromise;
      if (!this.id && !this.base64Content) {
        this.$notification.error("Добавьте файл анимации");
        return;
      }
      const result = await this.$api.AnimationService.updateAnimationAsync(
        new UpdateAnimationRequest({
          Id: this.id || null,
          Name: this.name.trim(),
          Base64Content: this.base64Content
        })
      );
      if (result) {
        this.$dialog.success(
          this.id ? "Анимация успешно обновлена" : "Анимация успешно добавлена"
        );
        this.$router.back();
      }
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
